import instance from './http'
import url from './url'
import { getBusinessType } from '@/constant'

export default {
  // 检测登录用户
  CheckUserLogin: (login) => instance.get(url.CheckUserLogin(login)),
  // 获取用户信息
  // 重置密码
  GetPhoneCode: (params) => instance.post(url.getPhoneCode(params)),
  GetBusinessPhoneCode: (account, type) =>
    instance.post(url.getBusinessPhoneCode(account, type)),
  GetEmailCode: (params) => instance.post(url.getEmailCode(params)),
  ResetPasswordByPhone: (params) =>
    instance.post(url.ResetPasswordByPhone, params),
  // 重置密码-邮箱
  ResetPasswordByEmail: (params) =>
    instance.post(url.ResetPasswordByEmail, params),
  // 通过邮箱注册
  RegisterByEmail: (params) =>
    instance.post(url.RegisterByEmail(params), params),
  // 通过手机注册
  RegisterByPhone: (params) =>
    instance.post(url.RegisterByPhone(params), params),
  // 第三方授权登录 获取授权配置
  GetAuthConfig: (params) => instance.post(url.GetAuthConfig, params),
  // 第三方登录 code获取授权信息
  GetAuthCode: (params, gi_guest) =>
    instance.post(url.GetAuthCode(gi_guest), params),
  // 第三方登录 静默获取code
  GetSilentCode: (params) => instance.post(url.GetSilentCode, params),
  // 验证用户名是否注册
  CheckUser: (params) =>
    instance.post(url.CheckUser, params),
  // 用户（密码）登录
  UserLogin: (params) => instance.post(url.UserLogin(params), params),
  // 用户(手机验证码)登录
  VerificationCodeLogin: (params) =>
    instance.post(url.VerificationCodeLogin(params), params),
  // 获取用户信息
  GetUserInfo: () => instance.get(url.GetUserInfo),
  // 绑定手机号，补全信息
  BindPhone: (params) => instance.post(url.BindPhone, params),
  BindEmail: (params) => instance.post(url.BindEmail, params),
  BindUser: (params) => instance.post(url.BindUser, params),
  // 主动要求刷新token操作
  UserRefreshToken: (data, refreshtoken) =>
    instance.post(url.UserRefreshToken, null, {
      params: data,
      headers: { Refresh_Token: refreshtoken },
    }),
  // 第三方登录(Aia)
  ThirdLogin: (params) => instance.post(url.ThirdLogin, params),
}
